export default function dasherize(snake_case) {
  return snake_case.replace(/_/g, '-');
}
